var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"component-container"},[(_vm.showLabel())?_c('label',{style:(_vm.lableStyle)},[_c('span',{staticClass:"xing",style:(_vm.required ? { color: '#f00' } : null)},[_vm._v("*")]),_vm._v(_vm._s(_vm.label))]):_vm._e(),_c('router-link',{style:(_vm.inputStyle),attrs:{"to":_vm.pageNo}},[_vm._v(" 点击填写 ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }